import styles from './Loader.module.css';

export const LoaderItem = () => {
	return (
		<div className="bg-primary rounded-[15px] border border-secondary p-4 animate-pulse w-full">
			{/* Top section - Car icon and basic info */}
			<div className="flex items-center gap-3 mb-3">
				{/* Car icon placeholder */}
				<div className={`w-8 h-8 bg-gray-200 rounded-full ${styles.shimmer}`} />

				<div className="flex-1">
					{/* Title placeholder (SUV) */}
					<div
						className={`w-12 h-4 bg-gray-200 rounded mb-1 ${styles.shimmer}`}
					/>
					{/* Subtitle placeholder (Creta or similar) */}
					<div className={`w-24 h-3 bg-gray-100 rounded ${styles.shimmer}`} />
				</div>

				<div className="text-right">
					{/* Price section */}
					<div
						className={`flex items-center gap-1 justify-end w-24 h-3 bg-gray-100 rounded ${styles.shimmer}`}
					/>
				</div>
			</div>

			{/* Bottom section - Electric badge and capacity info */}
			<div className="flex items-center justify-between">
				<div className="flex items-center gap-2">
					{/* Electric badge placeholder */}
					<div
						className={`w-9 h-5 bg-green-100 rounded-full ${styles.shimmer}`}
					/>
				</div>

				<div
					className={`flex items-center gap-4 w-16 h-3 bg-gray-200 rounded ${styles.shimmer}`}
				/>
			</div>
		</div>
	);
};

const Loader = () => {
	return (
		<div className="p-20 space-y-4">
			<LoaderItem />
			<LoaderItem />
			<LoaderItem />
		</div>
	);
};

export default Loader;
